const COVID19 = 'COVID-19'
const MEDICAL = 'Medical issue'
const HOME = 'Home/property issue'
const CAR = 'Car issue'

export default {
  COVID19,
  MEDICAL,
  HOME,
  CAR
}
